import { render, staticRenderFns } from "./HuchaListadoAportacionesItem.vue?vue&type=template&id=41c8eba0&scoped=true"
import script from "./HuchaListadoAportacionesItem.vue?vue&type=script&lang=js"
export * from "./HuchaListadoAportacionesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8eba0",
  null
  
)

export default component.exports